"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "UploadMultiple",
  props: {
    reportType: String,
    file_url_list: Array
  },
  data: function data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      uploadActionUrl: '/dev-api/file-upload' // fileList: this.file_url_list

    };
  },
  methods: {
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传jpg图片');
        return false;
      }

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!');
        return false;
      }
    },
    onSuccess: function onSuccess(res, file, fileList) {
      this.$emit("success", res, this.reportType);
    }
  }
};
exports.default = _default;